export const SHOP_PAGE_SLUG = "shop";

export const DISCONTINUED_CATEGORY_PARAM = "dcat";
export const DISCONTINUED_SKU_PARAM = "dsku";
